<template>
  <div>
  <div class="out_box">
    <div class="temp_t">
      <div>
        <el-button class="temp_t_btn" @click="openDialog" :disabled="hasPlugin">{{hasPlugin ? '已安装插件' : '安装浏览器插件'}}</el-button>
        <el-button class="temp_batch" @click="batchAsync('')">批量同步到素材</el-button>
        <el-button class="temp_plain" @click="tempExport" :disabled="!multipleSelection.length">按模板导出</el-button>
        <el-button class="temp_plain" @click="exportToExcel" :disabled="!multipleSelection.length">导出数据</el-button>
        <el-button class="temp_plain" @click="handleDelete" :disabled="!multipleSelection.length">批量删除</el-button>
        <ImageOperate class="t_opra" v-if="multipleSelection.length" ref="ImageOperateRef" :imageList="multipleSelection" />
      </div>
      <div>
        <el-date-picker
          v-model="searchTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <el-select v-model="searchForm.user_id" placeholder="请选择" class="t_adminselect" v-if="userRole.key != 'employee'" @change="getCaptureList">
          <el-option
            v-for="item in subAccountList"
            :key="item.id"
            :label="`${item.nickname}${item.id == $store.state.userInfo.id ? '(我)' : ''}`"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button class="search_btn" @click="tableSearch">
          搜索 
        </el-button>
      </div>
    </div>
    <el-checkbox-group class="line_out" v-model="multipleSelection" style="height: calc(100% - 104px);" @change="handleSelectionChange">
      <el-checkbox class="line_box" v-for="(item, index) in tableData" :label="item" :key="item.id">
        <div class="line_l">
          <div class="line_status" v-if="item.status === 0">同步中</div>
          <div class="line_l_img" @click.prevent>
            <el-image :src="item.status === 0 ? item.source_url : item.image_url" fit="contain" :preview-src-list="[item.image_url]"></el-image>
          </div>
        </div>
        <div class="line_r">
          {{ item.title }}
        </div>
      </el-checkbox>
    </el-checkbox-group>
    <div style="position: relative;">
      <div class="selected_num">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkedAll" @change="handleCheckedAll">全选</el-checkbox>
        <span v-if="multipleSelection.length"> 已选择 {{ multipleSelection.length }} 张</span> 
      </div>
      <el-pagination
        class="main_pagination"
        background
        layout="prev, pager, next, sizes"
        :page-sizes="[100, 200, 500, 1000, 2000]"
        :total="tableTotal"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="searchForm.limit"
      >
      </el-pagination>
    </div>
    <el-backtop :visibility-height="100"></el-backtop>
  </div>
    <collection-material-library
      ref="collection"
      @submit="handleMoveFile"
      title="素材列表"
      :isFilter="true"
    />
    <ExportAccordTemp ref="ExportAccordTempRef" pageType="acquisition" :dataIds="group_ids" />
  </div>
</template>
<script>
import { captureGetList, captureDelete, captureBatchSave, captureExportExcel } from "@/api/acquisition";
import { allSubGetList } from '@/api/subaccount'
import CollectionMaterialLibrary from "@/components/CollectionMaterialLibrary.vue";
import ExportAccordTemp from "@/components/ExportAccordTemp.vue";
import ImageOperate from "@/components/ImageOperate.vue";

import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  name: "setPicture",
  components: {CollectionMaterialLibrary, ExportAccordTemp, ImageOperate},
  data() {
    return {
      searchTime: [],
      hasPlugin: false,
      subAccountList: [{id: -1, nickname: '全部'}],
      searchForm: {
        page: 1,
        limit: 100,
        start_time: '',
        end_time: '',
        date: [],
        status: "",
        batch_number:'',
      },
      tableData: [],
      tableTotal: 0,
      checkedAll: false,
      isIndeterminate: false,
      multipleSelection: [],

      group_ids: [],
    };
  },
  created() {
    if(this.userRole.key != 'employee') {
      this.$set(this.searchForm, 'user_id', -1)
    }
    this.getSubList()
    this.updateStatus()
    this.getCaptureList();
  },
  computed: {
    userRole() {
      return this.$store.getters.userRole
    }
  },
  methods: {
    batchAsync(data) {
      let c = this.$refs.collection;
      if (data) {
        c.sourceList = [
          {
            id: data.id,
            type: data.type,
          },
        ];
      } else {
        c.sourceList = this.multipleSelection.map(item => item.id);
      }
      c.dialogTableVisible = true;
      // c.catalogue = this.folderTree

    },
    exportToExcel() {
      let ids = this.multipleSelection.map(item => item.id);
      if(ids.length) {
        captureExportExcel({ids: ids}).then(res => {
          this.$message.success("导出成功");
          FileSaver.saveAs(res.data.url, new Date() + '采集数据.xlsx');
        })
      }else {
        this.$message.warning("请选择要导出的图片");
      }
    },
    tempExport() {
      this.group_ids = this.multipleSelection.map(item => {return {id: item.id}});
      if(this.group_ids.length) {
        this.$refs.ExportAccordTempRef.dialogTempVisible = true
      }else {
        this.$message.warning("请选择要按模板导出的图片");
      }
      
    },
    handleMoveFile(idlist, targetId) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // let file_ids = []
      // let folder_ids = []
      // idlist.forEach(item => {
      //   if(item.type == 1) {
      //     folder_ids.push(item.id) 
      //   }else {
      //     file_ids.push(item.id)
      //   }
      // })
      captureBatchSave({ids: idlist, folder_id: targetId}).then((res) => {
        loading.close();
        this.$message.success(`保存${idlist.length}条数据到素材成功！`);
        // this.tableUpdate()
      }).catch(() => {
        loading.close();
      });
    },
    handleSelectionChange(val) {
      this.isIndeterminate = val.length > 0 && val.length < this.tableData.length
      this.checkedAll = val.length == this.tableData.length
      this.multipleSelection = val
    },
    handleCheckedAll(val) {
      this.multipleSelection = val ? this.tableData : []
      this.isIndeterminate = false;
    },
    handleDelete() {
      this.$confirm('是否删除该采集数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = this.multipleSelection.map(item => item.id)
        captureDelete({ids}).then(res => {
          this.$message.success(`删除${ids.length}条采集数据成功`)
          this.getCaptureList()
        })
      })
    },
    async updateStatus() {
      // 1. 检查是否在 Chrome 环境
      if (typeof chrome === "undefined") {
        this.$message.warning("请在 Chrome 浏览器中使用此功能");
        return;
      }

      // 2. 检查 chrome.runtime 是否可用
      if (!chrome.runtime) {
        this.$message.warning("无法访问 Chrome 扩展 API，请确保扩展已正确配置");
        return;
      }

      // 3. 发送消息
      // let cid = process.env.NODE_ENV === "development" ? 'golgclpeelienpjdneaboejalppidkec' : 'cfajmjfacdokhcepkcggfjmbfellnpeb';
      try {
        const response = await new Promise((resolve) => {
          chrome.runtime.sendMessage(
            "cfajmjfacdokhcepkcggfjmbfellnpeb", { type: "PING" },
            (response) => {
              if (chrome.runtime.lastError) {
                resolve({ error: chrome.runtime.lastError });
              } else {
                resolve(response);
              }
            }
          );
        });

        if (response.error) {
          // this.hasPlugin = false
          console.error("扩展通信失败:", response.error);
        } else {
          this.hasPlugin = true
          console.log("扩展响应:", response);
        }
      } catch (error) {
        // this.hasPlugin = false
        console.error("未知错误:", error);
      }
    },
    openDialog() {
      if(window.chrome) {
        window.open('https://chromewebstore.google.com/detail/pod%E6%9F%94%E6%80%A7%E5%AE%9A%E5%88%B6/cfajmjfacdokhcepkcggfjmbfellnpeb?hl=zh-CN&utm_source=ext_sidebar', '_blank');
      }else {
        alert("当前浏览器不支持 Chrome 扩展 API")
      }
      
    },
    getCaptureList(){
      captureGetList(this.searchForm).then(res=>{
        this.tableData = res.data.data;
        this.tableTotal = res.data.total;
      });
    },
    tableSearch() {
      if(this.searchTime && this.searchTime.length) {
        this.searchForm.start_time = this.searchTime[0]
        this.searchForm.end_time = this.searchTime[1]
      }else {
        this.searchForm.start_time = ''
        this.searchForm.end_time = ''
      }
      this.searchForm.page = 1
      this.getCaptureList()
    },
    handleCurrentChange(val){
      this.multipleSelection = []
      this.searchForm.page = val
      this.getCaptureList()
    },
    handleSizeChange(val) {
      this.multipleSelection = []
      this.searchForm.limit = val
      this.searchForm.page = 1
      this.getCaptureList()
    },
    getSubList() {
      allSubGetList().then(res => {
        this.subAccountList = this.subAccountList.concat(res.data)
      })
    }
  },
};
</script>
<style lang="scss" scoped>
// /deep/ .main_table th.el-table__cell.el-table-column--selection .el-checkbox__inner {
//     display: none !important;
//   }
.out_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  height: calc(100vh - 99px);
  .temp_t {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .temp_t_btn, .temp_batch, .temp_plain, .t_opra /deep/ .temp_plain {
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      width: 156px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      padding: 0;
    }
    .temp_t_btn {
      border: none;
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      color: #F7F8FA;
      cursor: pointer;
    }
    .temp_batch, .temp_plain {
      margin-left: 16px;
      border: 1px solid #132632;
      color: #132632;
      background: transparent;
    }
    .temp_plain, .t_opra /deep/ .temp_plain {
      width: 124px;
    }
    .t_adminselect {
      margin-left: 12px;
      margin-right: 12px;
      /deep/ .el-input__inner {
        background: transparent;
        border-radius: 8px;
      }
    }
    .search_btn {
      border-radius: 8px;
      background: linear-gradient(90deg, #4691E7 0%, #3186E5 100%);
      width: 84px;
      font-size: 14px;
      color: #FFFFFF;
      border: none;
      flex-shrink: 0;
    }
  }
  .temp_classi {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-top: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #EDEDED;
    .temp_classi_item {
      font-size: 16px;
      margin-left: 24px;
      // color: #EDEDED;
      cursor: pointer;
      span {
        font-size: 14px;
        color: #CCCCCC;
      }
      &.active {
        // color: #FFFFFF;
        font-weight: 600;
      }
    }
    .temp_classi_add {
      padding: 5px 18px;
      border-radius: 24px;
      font-size: 12px;
      margin-left: 24px;
      border: 1px solid #BFBFBF;
      cursor: pointer;
    }
  }
  .table_image {
    width: 240px;
    height: 320px;

  }
  .selected_num {
    position: absolute;
    height: 100%;
    line-height: 78px;
    color: #737373;
    font-size: 14px;
  }
  .el-pagination {
    position: relative;
    /deep/ .el-pagination__sizes {
      position: absolute;
      right: 16px;
      .el-select .el-input .el-input__inner {
        height: 36px;
        line-height: 36px;
        background-color: #F7F8FA;
        border: none;
        color: #595959;
      }
    }
  }
  .line_out {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 1%;
    overflow: auto;
    margin-top: 18px;
  }
  .line_box {
    width: 32.6%;
    border-radius: 8px;
    background: #F7F8FA;
    padding: 18px;
    border: 1px solid #FFFFFF;
    margin-bottom: 18px;
    margin-right: 0;
    /deep/ .el-checkbox__input {
      position: absolute;
      top: 42px;
      left: 42px;
    }
    /deep/ .el-checkbox__label {
      width: 100%;
      display: flex;
      // align-items: center;
      .line_l {
        flex-shrink: 0;
        width: 50%;
        border-radius: 4px;
        background: #FFFFFF;
        padding: 16px 8px;
        // border: 1px solid #343F5C;
        position: relative;
        .line_status {
          position: absolute;
          right: 8px;
          z-index: 2;
          background: #acaf0b;
          color: #fff;
          padding: 4px 8px;
          border-radius: 0 0 0 4px;
          font-size: 12px;
        }
        .el-checkbox {
          position: absolute;
          top: 24px;
          left: 16px;
          z-index: 2;
        }
        .line_l_img {
          position: relative;
          &::after {
            padding-top: 100%;
            content: '';
            display: block;
          }
          .el-image {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      .line_r {
        flex: 1;
        // align-self: stretch;
        border-radius: 4px;
        background: #FFFFFF;
        overflow: hidden;
        padding: 16px 8px;
        color: #222224;
        white-space: normal;
        word-wrap: break-word;
      }
    }
  }
}
</style>